import Logger from '../lib/logger';
import StorageService from '../lib/storage.service';
import { deepClone } from '../lib/util.functions';
import { DEFAULT_BUNDLE_DATA } from '../lib/constants';

class BundlerButton extends HTMLElement {
  NAME = 'BundlerButton'
  variantId
  productHandle
  price
  title
  image
  abortController

  constructor() {
    super();
    Logger.info(`${this.NAME} > constructor`);
  }

  connectedCallback() {
    Logger.info(`${this.NAME} > connectedCallback`);
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    this.addEventListener('click', () => this.onClick(), { signal });
  }

  disconnectedCallback() {
    Logger.info(`${this.NAME} > disconnectedCallback`);
    this.abortController.abort();
    this.abortController = null;
  }

  static get observedAttributes() {
    return ['data-variant-id', 'data-product-handle', /* 'data-price', */ 'data-title', 'data-image', 'data-disabled'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    Logger.info(`${this.NAME} > attributeChangedCallback`, name, newValue);
    switch (name) {
      case 'data-variant-id':
        this.variantId = newValue;
        break;

      case 'data-product-handle':
        this.productHandle = newValue;
        break;

      /* case 'data-price':
        this.price = wholeNumber(newValue);
        break; */

      case 'data-title':
        this.title = newValue;
        break;

      case 'data-image':
        if (newValue !== '') this.image =  newValue;
        break;

      case 'data-disabled':
        if (newValue === 'true') {
          this.style.pointerEvents = 'none';
          this.style.opacity = '0.65';
        } else {
          this.removeAttribute('style');
        }
        break;

      default:
        break;
    }
  }

  onClick() {
    Logger.info(`${this.NAME} > #onClick`);
    const bundleData = deepClone(DEFAULT_BUNDLE_DATA);
    bundleData.variantId = this.variantId;
    bundleData.quantity = 1;
    bundleData.price = 0;
    bundleData.title = this.title;
    bundleData.image = this.image;
    //
    StorageService.save(this.productHandle, bundleData, true);
    window.location.href = `/pages/${this.productHandle}`;
  }
}

customElements.define('bundler-button', BundlerButton);